import { useId } from "react";

type Pose = "neutre" | "ecoute" | "succes";

/** Mascotte de Grafton : l'orbe (version sobre). Cinq arcs = les cinq cerveaux ; ils tournent doucement quand Grafton réfléchit. */
export default function OrbeGrafton({ taille = 120, pose = "neutre", pensant = false }: { taille?: number; pose?: Pose; pensant?: boolean }) {
  const id = useId().replace(/:/g, "");
  const OR = "#c8a96e", NOIR = "#040406", cx = 300, cy = 300, R = 176;
  const arcs = [0, 1, 2, 3, 4].map((k) => {
    const a0 = ((-90 + 72 * k - 25) * Math.PI) / 180, a1 = ((-90 + 72 * k + 25) * Math.PI) / 180;
    return { d: `M${cx + R * Math.cos(a0)} ${cy + R * Math.sin(a0)} A${R} ${R} 0 0 1 ${cx + R * Math.cos(a1)} ${cy + R * Math.sin(a1)}`, o: 0.95 - 0.07 * k };
  });
  const dx = pose === "ecoute" ? 7 : 0;
  const yeux = [cx - 38, cx + 38];
  return (
    <svg width={taille} height={taille} viewBox="0 0 600 600" role="img" aria-label={`Grafton IA, ${pensant ? "il réfléchit" : pose === "ecoute" ? "il écoute" : pose === "succes" ? "objectif atteint" : "au repos"}`}>
      <defs>
        <radialGradient id={`aura${id}`} cx="50%" cy="50%" r="50%"><stop offset="0" stopColor={OR} stopOpacity=".30" /><stop offset=".6" stopColor={OR} stopOpacity=".08" /><stop offset="1" stopColor={OR} stopOpacity="0" /></radialGradient>
        <radialGradient id={`orbe${id}`} cx="36%" cy="30%" r="80%"><stop offset="0" stopColor="#f6e7bf" /><stop offset=".45" stopColor={OR} /><stop offset="1" stopColor="#7d6430" /></radialGradient>
        <style>{`@keyframes orbe-tourne{to{transform:rotate(360deg)}}@media (prefers-reduced-motion:reduce){.orbe-arcs{animation:none!important}}`}</style>
      </defs>
      <circle cx={cx} cy={cy} r="280" fill={`url(#aura${id})`} />
      <g className="orbe-arcs" style={pensant ? { transformOrigin: "300px 300px", animation: "orbe-tourne 7s linear infinite" } : undefined}>
        {arcs.map((a, i) => <path key={i} d={a.d} fill="none" stroke={OR} strokeWidth="22" strokeLinecap="round" strokeOpacity={a.o} />)}
      </g>
      <circle cx={cx} cy={cy} r="120" fill={`url(#orbe${id})`} />
      <ellipse cx={cx - 46} cy={cy - 60} rx="32" ry="15" transform={`rotate(-32 ${cx - 46} ${cy - 60})`} fill="#fff" fillOpacity=".30" />
      {pose === "succes"
        ? yeux.map((ex) => <path key={ex} d={`M${ex - 15} ${cy + 10} Q${ex} ${cy - 10} ${ex + 15} ${cy + 10}`} fill="none" stroke={NOIR} strokeWidth="9" strokeLinecap="round" />)
        : yeux.map((ex) => <rect key={ex} x={ex - 9 + dx} y={cy - 18} width="18" height="44" rx="9" fill={NOIR} />)}
    </svg>
  );
}
